module.exports = __webpack_public_path__ + "img/02.88eb4806.jpg";